import { render, staticRenderFns } from "./PatientPhotos.vue?vue&type=template&id=0fec17fb"
import script from "./PatientPhotos.vue?vue&type=script&lang=js"
export * from "./PatientPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports